import React, { FunctionComponent } from 'react';
import i18next from 'core/i18n';
import { Button, MediumTitle, palettes } from '@indigo-ag/component-module';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconDefinition } from '@fortawesome/pro-regular-svg-icons';

import { createStylesHook } from 'shared';

interface BlankStateProps {
  onClickButton?: () => void;
  title: string;
  description?: string;
  icon: IconDefinition;
  height?: string;
}

const useStyles = createStylesHook(({ typography: { pxToRem } }) => ({
  layout: {
    display: 'flex',
    height: 'auto',
    justifyContent: 'space-around',
    width: '100%'
  },
  description: {
    color: palettes.brand.gray[800],
    fontSize: pxToRem(13)
  },
  blankSate: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    textAlign: 'center',
    maxWidth: '340px',
    margin: '46px auto',
    justifyContent: 'center'
  }
}));

export const BlankState: FunctionComponent<BlankStateProps> = ({
  onClickButton,
  title,
  description,
  icon,
  height = '14rem'
}) => {
  /**
   * Styles
   */
  const classes = useStyles();

  const handleClick = () => {
    if (onClickButton) {
      onClickButton();
    }
  };
  return (
    <div className={classes.layout}>
      <div className={classes.blankSate} style={{ height }}>
        <FontAwesomeIcon icon={icon} size="4x" color={palettes.brand.gray['400']} />
        <MediumTitle style={{ margin: '14px 0px' }}>{title}</MediumTitle>
        <span className={classes.description}>{description}</span>
        {onClickButton && (
          <Button size="small" onClick={handleClick} style={{ marginTop: 14 }}>
            {i18next.t('newConversation')}
          </Button>
        )}
      </div>
    </div>
  );
};
